import { ClerkProvider } from "@clerk/react";
import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import { HelmetProvider } from "react-helmet-async";
import "@radix-ui/themes/styles.css";
import "./styles/radix-theme.css";
import App from "./App";
import "./index.css";
import "./fonts.css";
import config from "./config";
import { initSentry } from "./utils/sentry";

// Force fresh CI build — see git history for context.
initSentry();

if (config.posthog.key) {
  posthog.init(config.posthog.key, {
    api_host: config.posthog.host,
    capture_pageview: false,
    capture_pageleave: true,
    mask_all_text: false,
    mask_all_element_attributes: false,
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* ponytail: only mount ClerkProvider when configured — a build without
          the key (e.g. CI before the secret is added) renders the app fine;
          the Clerk routes just stay inert until the key is present. */}
      {clerkKey ? (
        <ClerkProvider publishableKey={clerkKey} afterSignOutUrl="/">
          <App />
        </ClerkProvider>
      ) : (
        <App />
      )}
    </HelmetProvider>
  </React.StrictMode>,
);
